import { withAnalyticOnEvent } from 'react-shisell';

export default withAnalyticOnEvent<any>({
    eventName: 'onClick',
    analyticName: 'Click',
})('input' as any);



// WEBPACK FOOTER //
// ./packages/platform-common-ui/AnalyticButtonInput.tsx